<template>
  <div>
    <router-view />
    <div class="toast-container">
      <transition-group name="toast-fade">
        <div v-for="t in toasts" :key="t.id" class="toast-item" :class="'toast-' + t.type">
          {{ t.msg }}
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() { return { toasts: [] } },
  mounted() {
    window.addEventListener('psh-toast', e => {
      const id = Date.now() + Math.random()
      this.toasts.push({ id, msg: e.detail.msg, type: e.detail.type || 'warn' })
      setTimeout(() => { this.toasts = this.toasts.filter(t => t.id !== id) }, 4000)
    })
  }
}
</script>

<style>
.toast-container {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  z-index: 9999; pointer-events: none;
}
.toast-item {
  padding: 9px 20px; border-radius: 6px; font-size: 13px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  white-space: nowrap; max-width: 480px; overflow: hidden; text-overflow: ellipsis;
  backdrop-filter: blur(6px);
}
.toast-warn  { background: rgba(30,55,90,0.92); border: 1px solid rgba(255,180,71,0.5); color: #ffb547; }
.toast-error { background: rgba(40,10,20,0.92); border: 1px solid rgba(255,92,122,0.5); color: #ff5c7a; }
.toast-info  { background: rgba(10,30,55,0.92); border: 1px solid rgba(0,212,255,0.4); color: #00d4ff; }
.toast-fade-enter-active, .toast-fade-leave-active { transition: all .3s ease; }
.toast-fade-enter, .toast-fade-leave-to { opacity: 0; transform: translateY(12px); }

:root {
  --bg: #05111f; --bg2: #0a1c33; --panel: #0f2749; --panel-hi: #143660;
  --line: #1e4a82; --cyan: #00d4ff; --cyan-dim: #0a8ca8;
  --orange: #ffb547; --green: #3ddc97; --red: #ff5c7a; --yellow: #ffd47a;
  --text: #e6f2ff; --text-dim: #8aa4c7; --text-mute: #5f7ba0;
}
* { box-sizing: border-box; margin: 0; padding: 0; }
html, body {
  height: 100%;
  background: radial-gradient(ellipse at top, #0a2040 0%, var(--bg) 70%);
  color: var(--text);
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
  font-size: 14px; overflow-x: hidden;
}
button { font-family: inherit; cursor: pointer; }
a { color: var(--cyan); text-decoration: none; cursor: pointer; }
</style>
